export default __webpack_public_path__ + "static/media/fuhr1.29a93b6e.svg";